import { Grid, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { WrapFormElementProps } from './index';
import useBundleTranslation from 'i18n';
import React, { useEffect } from 'react';
import { arrayMoveImmutable } from 'array-move';
import IconMi from 'components/common/icon/IconMi';

interface SortableListProps {
    items: React.ReactNode[];
    onSortEnd: ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }) => void;
    useDragHandle?: boolean;
}

const DragHandle = SortableHandle(() => <IconMi icon="drag-and-drop-grid" sx={{ zIndex: 2, cursor: 'grab' }} />);

const SortableItem = SortableElement(({ child }: { child: React.ReactNode }) => (
    <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
        <DragHandle />
        {child}
    </div>
));

const SortableList = SortableContainer<SortableListProps>(({ items }: { items: React.ReactNode[] }) => (
    <Stack spacing={0.5}>
        {items.map((child, index) => {
            return (
                // @ts-ignore
                <SortableItem key={index} index={index} child={child}></SortableItem>
            );
        })}
    </Stack>
));

export default function FormDraggableWrapperGroup({ elementProps, children }: WrapFormElementProps) {
    const { t } = useBundleTranslation([elementProps.translationNS ?? 'main']);
    const label = elementProps.componentProps.translate
        ? t(elementProps.componentProps.label as string)
        : elementProps.componentProps.label;

    const [items, setItems] = React.useState([children]);

    useEffect(() => {
        setItems(children);
    }, [children]);

    const onSortEnd = ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }) => {
        if (oldIndex !== newIndex) {
            setItems((prev) => {
                const newItems = arrayMoveImmutable(prev, oldIndex, newIndex);

                newItems.forEach((el: any, idx) => {
                    if (React.isValidElement(el)) {
                        // @ts-ignore
                        elementProps.form.hookFormSetValue(el?.props?.component?.props?.displayOrder as any, idx, {
                            shouldDirty: true,
                        });
                    }
                });

                return newItems;
            });
        }
    };

    return (
        <Grid item xs={elementProps.componentProps.xs} className={'form-wrapper-group'}>
            {label && <Typography variant="body1">{label}</Typography>}
            <SortableList items={items} useDragHandle onSortEnd={onSortEnd} />
        </Grid>
    );
}
